var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 0.32666C5.3042 0.32666 0.777344 5.05479 0.777344 10.8876C0.777344 16.7204 5.3042 21.4485 10.8887 21.4485C16.4732 21.4485 21.0001 16.7204 21.0001 10.8876C21.0001 5.05479 16.4732 0.32666 10.8887 0.32666ZM10.8887 16.1681C10.3306 16.1681 9.87757 15.6949 9.87757 15.112V10.8876C9.87757 10.3046 10.3306 9.8315 10.8887 9.8315C11.4469 9.8315 11.8998 10.3046 11.8998 10.8876V15.112C11.8998 15.6949 11.4469 16.1681 10.8887 16.1681ZM11.3943 7.71931H10.3831C10.1041 7.71931 9.87757 7.48275 9.87757 7.19127V6.13517C9.87757 5.84369 10.1041 5.60713 10.3831 5.60713H11.3943C11.6733 5.60713 11.8998 5.84369 11.8998 6.13517V7.19127C11.8998 7.48275 11.6733 7.71931 11.3943 7.71931Z",
    fill: "#FD1A94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.2b6dde62269255fe4aad01dca1b2431a.svg";
export { ForwardRef as ReactComponent };